export default __webpack_public_path__ + "static/media/purina_logo.30ca8ffd.svg";